import React from 'react';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

import makeClasses from './styles';

const Notification = ({ data: { id, message, canBeDeleted = false, html = false }, onClose, canClose }) => {
  const classes = makeClasses();

  const handleOnClose = () => {
    onClose(id);
  };

  return (
    <div className={classes.root}>
      <InfoOutlinedIcon solor="inherit" className={classes.infoIcon} />
      {html ? <div dangerouslySetInnerHTML={{ __html: message }} /> : <div>{message}</div>}
      {canBeDeleted && canClose ? (
        <div onClick={handleOnClose} className={classes.closeButton}>
          <CloseOutlinedIcon color="inherit" className={classes.closeIcon} />
        </div>
      ) : null}
    </div>
  );
};

export default Notification;
